import { LABELS, SIDEBAR_TEXTS } from "@/utils/constants/appConstants/commonConstants";
import type { FormListType } from "@/services/form.service";

export const FormType = {
    form: {
        pageTitle: SIDEBAR_TEXTS.Forms,
        cachePageId: "forms",
        detailsPath: "/form-details",
        tableId: "form-table",
        transferTitle: LABELS.TRANSFER_FORM_OWNERSHIP,
        transferDescription: LABELS.TRANSFER_FORM_OWNERSHIP_DESCRIPTION,
        bulkTransferDescription: LABELS.BULK_TRANSFER_FORM_OWNERSHIP_DESCRIPTION,
        icon: "ni-notes-alt",
    },
    webform: {
        pageTitle: SIDEBAR_TEXTS.WebForms,
        cachePageId: "web-forms",
        detailsPath: "/web-form-details",
        tableId: "web-form-table",
        transferTitle: LABELS.TRANSFER_WEB_FORM_OWNERSHIP,
        transferDescription: LABELS.TRANSFER_WEB_FORM_OWNERSHIP_DESCRIPTION,
        bulkTransferDescription: LABELS.BULK_TRANSFER_WEB_FORM_OWNERSHIP_DESCRIPTION,
        icon: "ni-globe",
    },
} as const;

export type FormTypeKey = keyof typeof FormType;

/** Maps API/list type (`pdf` | `web`) to FormType keys (`form` | `webform`). */
export const FORM_LIST_TYPE_KEY: Record<FormListType, FormTypeKey> = {
    pdf: "form",
    web: "webform",
};
